import Vue from 'vue';
import Vuex from 'vuex';

import main from './main';
import favourite from "./favourite";
import td from './td';
import routeInfo from './routeInfo';
import googleMap from './googleMap';
import nearbyRoutes from './nearbyRoutes';
import stopMenu from './stopMenu';
import p2p from "./p2p";
import history from "./history";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    main,
    favourite,
    td,
    googleMap,
    routeInfo,
    nearbyRoutes,
    stopMenu,
    p2p,
    history,
  }
});

export default store;
